// Dipti (Custom Js)
$(document).ready(function () {
  ProductGridSlider(); // Default Call
  $(document).on(
    "click",
    ".product-card .card__media .slick_slider .slick-arrowIcon",
    function (e) {
      e.stopPropagation();
      e.preventDefault();
    }
  );

  $(document).on("click",".selector-wrapper.option-color .single-label, .product-card .option-color .slick-arrow",function (e) {
      let ProductCardMedia = $(this).closest(".product-card").find(".ProductCardMedia .slick_slider");
      let selectedVar;
      if ($(this).hasClass("slick-arrow")) {
        //selectedVar = $(this).parent().find(".slick-center").attr("data-value").toLowerCase().replace(" + ", "-").replace("/", "-").replace(" ", "-");
        selectedVar = $(this).parent().find(".slick-center").attr("data-title");
      } else {
        //selectedVar = $(this).attr("title").toLowerCase().replace(" + ", "-").replace("/", "-").replace(" ", "-");
        selectedVar = $(this).attr("data-title");
      }
      $(ProductCardMedia).slick("unslick");
      $(ProductCardMedia).empty();
      $($(this).closest(".product-card").find(".ProductImageList img")).each(
        function () {
          //let modifyImgALT = $(this).attr("alt").toLowerCase().replace("_main", "").replace("_model", "");
          let modifyImgALT = $(this).attr("data-title").replace("_main", "").replace("_model", "");
          if (selectedVar == modifyImgALT) {
            $(this).clone().appendTo(ProductCardMedia);
          }
          if (modifyImgALT == "default") {
            $(this).clone().appendTo(ProductCardMedia);
          }
        }
      );
      $(ProductCardMedia).slick({
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow:
          '<button type="button" data-role="none" class="slick-next slick-arrowIcon"><svg xmlns="http://www.w3.org/2000/svg" width="21.128" height="15.854" viewBox="0 0 21.128 15.854"><path id="arrow_right_alt_FILL0_wght400_GRAD0_opsz48" d="M173.218,348.855,171.8,347.47l5.538-5.538H160v-1.978h17.338l-5.571-5.57L173.185,333l7.944,7.944Z" transform="translate(-160 -333)" fill="#191717" opacity="0.5"/></svg></button>',
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev slick-arrowIcon"><svg xmlns="http://www.w3.org/2000/svg" width="21.128" height="15.854" viewBox="0 0 21.128 15.854"><path id="arrow_right_alt_FILL0_wght400_GRAD0_opsz48" d="M173.218,348.855,171.8,347.47l5.538-5.538H160v-1.978h17.338l-5.571-5.57L173.185,333l7.944,7.944Z" transform="translate(181.128 348.854) rotate(180)" fill="#191717" opacity="0.5"/></svg></button>',
      });
    }
  );

  // mobile color click change main iamge
  // $(document).on("click", ".color_option", function () {
  //   console.log("button clicked");
  //   $($(this).closest(".").find(""))
  // });

  // In the Product Grid when select the Any color remove the class and add
  $(document).on("click",".product-card-info .swatch.option-color .swatch-element label, .product-card-info .swatch.option-size .swatch-element a",function (e) {
      let varID = "";
      if ($(this).hasClass("sizeOption")) {
        varID = $(this).closest(".product-card-form").find(".option-color .slick-center .single-label").data("varid");
      } else {
        varID = $(this).data("varid");
      }

      let currentprice = $(this).data('varidprice');
      $(this).closest(".product-card-info").find(".price").find(".amount").html(currentprice);
      
      let getHandle = $(this).closest(".product-card").attr("productHandle");
      getHandle = `/products/${getHandle}?variant=${varID}`;
      $(this).closest(".product-card").find(".product-card-title").attr("href", getHandle);
      $(this).closest(".product-card").find(".ProductCardMedia .mediaSlider").attr("href", getHandle);
      $(this).closest(".product-card").find(".product-card-info .option-size .single-label").attr("href", getHandle);
    }
  );

  // In the Product Grid when select the Any color remove the class and add
  $(document).on(
    "click",
    ".product-card-info .swatch.option-color .swatch-element",
    function (e) {
      $(this).parent().find(".slick-center").removeClass("slick-center");
      $(this).addClass("slick-center");
    }
  );

  // On Thumbnail Click Change the main product Image
  function mainImage() {
    if ($("#Product-Slider .active .ProductImg").length != 0) {
      let MainImag = $(
        "#Product-Slider .active .product-single__media-zoom"
      ).attr("href");
      $(".product-big-image img").attr("src", MainImag);
      // if (
      //   $("#Product-Slider .active .ProductImg").attr("alt").includes("model")
      // ) {
      //   $(".product-big-image img").addClass("model-image");
      // } else {
      //   $(".product-big-image img").removeClass("model-image");
      // }
      //
      const srcElem = document.querySelector(
        "#Product-Slider .active .product-single__media-zoom"
      );
      $(".product-big-image .product-single__media-zoom").attr(
        "data-target-thumbnail",
        srcElem.parentNode.id
      );
    }
  }
  if ($("#Product-Slider").length != 0) {
    $("#Product-Slider .product-images__slide:first-child").addClass("active");
    mainImage();
  }

  // on product page Click Thumbmail chnage the main Img
  $(document).on(
    "click",
    "#Product-Slider .product-images__slide",
    function () {
      $("#Product-Slider .product-images__slide").removeClass("active");
      $(this).addClass("active");
      mainImage();
    }
  );

  // In Product Grid variant wise add class
  $(".product-card.product-item").each(function () {
    if (
      $(this).find(".selector-wrapper-1").length != 0 &&
      $(this).find(".selector-wrapper-2").length != 0
    ) {
      $(this).addClass("multi-verients");
    } else {
      $(this).addClass("single-verients");
    }
  });

  // On click colour chnage the Product images
  //   $(document).on(
  //     "click",
  //     ".selector-wrapper.option-color .single-label, \
  //     .product-card .option-color .slick-arrow",
  //     function () {
  //       let BtnText;
  //       if ($(this).hasClass("slick-arrow")) {
  //         BtnText = `${$(this)
  //           .parent()
  //           .find(".slick-center")
  //           .attr("data-value")
  //           .toLowerCase()}_main`;
  //       } else {
  //         BtnText = `${$(this)
  //           .attr("title")
  //           .toLowerCase()
  //           .replace(" + ", "-")
  //           .replace("/", "-")
  //           .replace(" ", "-")}_main`;
  //       }
  //       const sliderData = $(this).closest(".product-card").find(".ProductCardMedia");
  //       $(sliderData).find(".slick-slide").each(function () {
  //         let ImgALT = $(this).attr("alt").toLowerCase();
  //         if (BtnText == ImgALT) {
  //           // let sliderDataID = $(this).attr("data-id");
  //           // let productSlider = $(sliderData).find(".slick_slider");
  //           // $(productSlider).slick("slickGoTo", sliderDataID);
  //         }
  //       });
  //     }
  //   );
  // });

  var $body = $("body"),
    $doc = $(document),
    $html = $("html"),
    $win = $(window);

  // product add in add to cart
  $doc.on(
    "click",
    ".product-card .option-color .single-option, .product-card .option-color .slick-arrow svg, .product-card .option-size .single-option",
    (event) => {
      var $target = $(event.target),
        product = $target.parents(".product-item"),
        productJson = product.data("json-product"),
        variantList,
        optionColor = product.find(".option-color").data("option-position"),
        optionIndex = $target
          .closest("[data-option-index]")
          .data("option-index"),
        thisVal = $target.val(),
        selectedVariant,
        selectedOption1 = product
          .find(".selector-wrapper-1")
          .find("input:checked")
          .val(),
        selectedOption2 = product
          .find(".selector-wrapper-2")
          .find("input:checked")
          .val(),
        selectedOption3 = product
          .find(".selector-wrapper-3")
          .find("input:checked")
          .val();
      if ($target.closest(".selector-wrapper").hasClass("option-color")) {
        thisVal = $target
          .closest(".selector-wrapper")
          .find(".swatch-element.slick-center")
          .data("value");
        $target
          .closest(".selector-wrapper")
          .find(".swatch-element input")
          .prop("checked", false);
        $target
          .closest(".selector-wrapper")
          .find(".swatch-element.slick-center input")
          .prop("checked", true);
      }

      if (productJson != undefined) {
        variantList = productJson.variants;
      }

      switch (optionIndex) {
        case 0:
          var availableVariants = variantList.find((variant) => {
            if (optionColor == 1) {
              return (
                variant.option2 == thisVal && variant.option1 == selectedOption2
              );
            } else {
              if (optionColor == 2) {
                return (
                  variant.option3 == thisVal &&
                  variant.option1 == selectedOption2
                );
              } else {
                return (
                  variant.option1 == thisVal &&
                  variant.option2 == selectedOption2
                );
              }
            }
          });
          if (availableVariants != undefined) {
            selectedVariant = availableVariants;
          } else {
            var altAvailableVariants = variantList.find((variant) => {
              if (optionColor == 1) {
                return variant.option2 == thisVal;
              } else {
                if (optionColor == 2) {
                  return variant.option3 == thisVal;
                } else {
                  return variant.option1 == thisVal;
                }
              }
            });
            selectedVariant = altAvailableVariants;
          }
          break;

        case 1:
          var availableVariants = variantList.find((variant) => {
            if (optionColor == 1) {
              return (
                variant.option2 == selectedOption1 &&
                variant.option1 == thisVal &&
                variant.option3 == selectedOption2
              );
            } else {
              if (optionColor == 2) {
                return (
                  variant.option3 == selectedOption1 &&
                  variant.option1 == thisVal &&
                  variant.option2 == selectedOption2
                );
              } else {
                return (
                  variant.option1 == selectedOption1 &&
                  variant.option2 == thisVal &&
                  variant.option3 == selectedOption2
                );
              }
            }
          });
          if (availableVariants != undefined) {
            selectedVariant = availableVariants;
          } else {
            var altAvailableVariants = variantList.find((variant) => {
              if (optionColor == 1) {
                return (
                  variant.option2 == selectedOption1 &&
                  variant.option1 == thisVal
                );
              } else {
                if (optionColor == 2) {
                  return (
                    variant.option3 == selectedOption1 &&
                    variant.option1 == thisVal
                  );
                } else {
                  return (
                    variant.option1 == selectedOption1 &&
                    variant.option2 == thisVal
                  );
                }
              }
            });
            selectedVariant = altAvailableVariants;
          }
          break;

        case 2:
          var availableVariants = variantList.find((variant) => {
            if (
              variant.option1 == selectedOption1 &&
              variant.option2 == selectedOption2
            ) {
              return variant.id;
            }
          });
          if (availableVariants != undefined) {
            selectedVariant = availableVariants;
          }
          break;
      }

      if (selectedVariant == undefined) {
        return;
      } else {
        $(".product-card-form").find("[name=id]").val(selectedVariant.id);
        $target
          .parents(".selector-wrapper")
          .find(".form-label span")
          .text(thisVal);
        if (checkNeedToConvertCurrency()) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }

        if ($target.closest(".selector-wrapper").hasClass("option-size")) {
          onSubmitHandler();
          $("body").addClass("open-cc open-cart");
          $("#Cart-Drawer").addClass("active");
        } else {
          $(".product-card-form .option-size .swatch-element").removeClass(
            "soldout"
          );
          let ok = false;
          variantList.find((variant) => {
            if (variant.option1 == thisVal) {
              if (!ok) {
                ok = true;
                const price = variant.price;
                let country = Shopify.country;
                const formattedPrice =
                  "₹ " +
                  (price / 100).toLocaleString(`en-${country}`, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  });
                $target
                  .closest(".product-card-info")
                  .find(".titleBlock .price .amount")
                  .text(formattedPrice);
              }
              if (!variant.available) {
                let size_val = variant.option2;
                let div_sizeNotAva = $target
                  .closest(".product-card-form")
                  .find(".option-size .swatch-element");
                $(div_sizeNotAva).each(function () {
                  let dataVal = $(this).attr("data-value");
                  if (size_val == dataVal) {
                    $(this).addClass("soldout");
                  }
                });
              }
            }
          });
        }
      }
    }
  );

  function checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  function showWarning(content, time = this.warningTime) {
    if (this.warningTimeout) {
      clearTimeout(this.warningTimeout);
    }
    this.warningPopupContent.textContent = content;
    document.body.classList.add("has-warning");
    if (time) {
      this.warningTimeout = setTimeout(() => {
        document.body.classList.remove("has-warning");
      }, time);
    }
  }

  function onSubmitHandler() {
    var form = $(".product-card-form").closest("form")[0];
    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
    };
    let formData = new FormData(form);
    if (formData) {
      formData.append(
        "sections",
        getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);
      config.body = formData;
      fetch(window.Shopify.routes.root + "cart/add.js", config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent("product:variant-error", {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.description,
              message: response.message,
            });
            handleErrorMessage(response.description);
            return;
          }
          renderContents(response);
          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          // console.log(e);
        });
    }
    function getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }

    function renderContents(parsedState) {
      getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      let product_drawer = document.getElementById("Product-Drawer");
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
        document.body.classList.remove("open-quick-view");
        if (window.innerWidth < 1069) {
          product_drawer.classList.remove("active");
          if (document.getElementById("Cart-Drawer")) {
            document.getElementById("Cart-Drawer").classList.add("active");
            document.body.classList.add("open-cart");
            document
              .getElementById("Cart-Drawer")
              .querySelector(".product-recommendations--full")
              .classList.add("active");
            dispatchCustomEvent("cart-drawer:open");
          }
        } else {
          product_drawer
            .querySelector(".product-quick-images--container")
            .addEventListener("transitionend", function () {
              product_drawer.classList.remove("active");
              if (document.getElementById("Cart-Drawer")) {
                document.getElementById("Cart-Drawer").classList.add("active");
                document.body.classList.add("open-cart");
                document
                  .getElementById("Cart-Drawer")
                  .querySelector(".product-recommendations--full")
                  .classList.add("active");
                dispatchCustomEvent("cart-drawer:open");
              }
            });
        }
        if (!document.getElementById("Cart-Drawer")) {
          document.body.classList.remove("open-cc");
        }
      } else if (document.getElementById("Cart-Drawer")) {
        document.body.classList.add("open-cc");
        document.body.classList.add("open-cart");
        document.getElementById("Cart-Drawer").classList.add("active");
        dispatchCustomEvent("cart-drawer:open");
      }
    }
    function getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    function handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
});

function triggerProductImgThumb(event) {
  event.preventDefault();
  const clickedEl = event.currentTarget;
  const targetId = clickedEl.getAttribute("data-target-thumbnail");
  const evt = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  const $targetThumbElem = $(`#${targetId} .product-single__media-zoom`);
  $targetThumbElem[0].dispatchEvent(evt);
  // BUG: $targetThumbElem.trigger('mousedown')
}
// CUSTOM CODE
var links = document.links; 
let linksLength = links.length;
let  ii = 0;
for (let i = 0; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) { 
    //links[i].target = '_blank';
    //links[i].rel = 'noreferrer noopener';
    } 
}
